module.exports = __webpack_public_path__ + "static/media/edge_exploded_GreatStellatedDodecahedron.b35676ba.gif";